/**
 * Client-side data access for cross-cutting reference data.
 * Centralizes the `/api` route strings + the active-only transform, and
 * preserves the `countries-list` / `industries-list` keys that the generic
 * Country/Industry selects read back via `useNuxtData`.
 */
export const useBaseDataRepository = () => {
  const getCountries = () =>
    useLazyFetch('/api/v1/countries', {
      key: 'countries-list',
      transform: (data: TApiCountry[]) =>
        data.filter((country) => country.is_active),
    })

  const getIndustries = () =>
    useLazyFetch('/api/v1/industries', {
      key: 'industries-list',
      transform: (data: TApiIndustry[]) =>
        data.filter((industry) => industry.is_active),
    })

  return { getCountries, getIndustries }
}
